/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SkuTypeEnum = 'REGULAR' | 'NOT_FOR_RESALE';

export const SkuTypeEnum = {

    REGULAR: 'REGULAR' as SkuTypeEnum,

    NOT_FOR_RESALE: 'NOT_FOR_RESALE' as SkuTypeEnum
};

